import { Component } from 'react';
import { HexAlphaColorPicker, HexColorInput } from 'react-colorful';
import getCheckboxField from '../../fields/checkbox';
import getSelectField from '../../fields/select';
import getFonts from '../../../Functions/config/fonts';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';

class YelpReviews extends Component {
    constructor(props) {
        super(props);
    }

    setColorsAndPreview = async (section, type, color) => {
        const { setColorsAndPreview } = this.props;
        await setColorsAndPreview(section, type, color);
    };

    setReviewTextColor = async (color) => {
        await this.setColorsAndPreview('reviews', 'reviewtextColor', color);
    };

    setContainerBgColor = async (color) => {
        await this.setColorsAndPreview('reviews', 'containerBgColor', color);
    };

    setContainerBorderColor = async (color) => {
        await this.setColorsAndPreview('reviews', 'containerBorderColor', color);
    };

    setCardBgColor = async (color) => {
        await this.setColorsAndPreview('cards', 'cardBgColor', color);
    };

    setCardBorderColor = async (color) => {
        await this.setColorsAndPreview('cards', 'cardBorderColor', color);
    };

    setCardTextColor = async (color) => {
        await this.setColorsAndPreview('cards', 'cardTextColor', color);
    };

    setReadButtonTextColor = async (color) => {
        await this.setColorsAndPreview('button', 'readButtonTextColor', color);
    };

    setReadButtonHoverColor = async (color) => {
        await this.setColorsAndPreview('button', 'readButtonHoverColor', color);
    };

    render() {
        const { widget, handleInputChange, toggleColorPicker } = this.props;
        const { yelp } = widget.htmlData;
        const fontOptions = getFonts();
        const filterOptions = [
            { value: 'all', label: 'All Reviews' },
            { value: '5', label: '5 stars' },
            { value: '4', label: '4 stars and up' },
            { value: '3', label: '3 stars and up' },
            { value: '2', label: '2 stars and up' },
            { value: '1', label: '1 star and up' },
        ];
        const layoutOptions = [
            { value: 'list', label: 'List' },
            { value: 'masonry', label: 'Masonry' },
            { value: 'carousel', label: 'Carousel' },
        ];

        return (
            <div className="mjwi-acc-panel-wrapper">
                <div className="mjwi-row">
                    <div className="mjwi-col50">
                        <label>Filter</label>
                    </div>
                    <div className='mjwi-col55 mjwi-row'>
                        <select
                            name="reviewFilter"
                            value={yelp.reviews.reviewFilter}
                            onChange={handleInputChange}
                        >
                            {filterOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className='mjwi-row'>
                    <div className="mjwi-col50">
                        <label>Layout</label>
                    </div>
                    <div className='mjwi-col50 mjwi-row'>
                        <select
                            name="reviewlayout"
                            value={yelp.reviews.reviewlayout}
                            onChange={handleInputChange}
                        >
                            {layoutOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="mjwi-row">

                    <label>Text Font Family</label>
                    <div className="mjwi-col50 mjwi-row ">
                        {getSelectField('reviewtextFontFamily', fontOptions, yelp.reviews.reviewtextFontFamily, handleInputChange)}
                    </div>
                </div>
                <div className="mjwi-row">
                    <label>Text</label>

                    <div className="mjwi-row mjwi-col33">
                        <input
                            type="number"
                            name="cardtextFontSize"
                            value={yelp.cards.cardtextFontSize || ''}
                            onChange={handleInputChange}
                        /> px
                    </div>
                    <div className="mjwi-col50  mjwi-clr-picker">
                        <span
                            className="clrPickerVal"
                            onClick={toggleColorPicker}
                            style={{ backgroundColor: yelp.cards.cardTextColor }}
                        ></span>
                        <HexAlphaColorPicker
                            color={yelp.cards.cardTextColor}
                            onChange={this.setCardTextColor}
                            style={{ display: 'none' }}
                            className="mjwi-apfl-color-picker"
                        />
                        <HexColorInput
                            color={yelp.cards.cardTextColor}
                            onChange={this.setCardTextColor}
                        />
                    </div>
                </div>
                <Accordion allowZeroExpanded={true}>
                    <AccordionItem className="mjwi-sub-accordion">
                        <AccordionItemHeading>
                            <AccordionItemButton>Card</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div className="mjwi-acc-panel-wrapper">
                                <div className='mjwi-row'>
                                    <div className="mjwi-col50">
                                        <label>Heading</label>
                                    </div>
                                    <div className="mjwi-col50 mjwi-clr-picker">
                                        <span
                                            className="clrPickerVal"
                                            onClick={toggleColorPicker}
                                            style={{ backgroundColor: yelp.reviews.reviewtextColor }}
                                        ></span>
                                        <HexAlphaColorPicker
                                            color={yelp.reviews.reviewtextColor}
                                            onChange={this.setReviewTextColor}
                                            style={{ display: 'none' }}
                                            className="mjwi-apfl-color-picker"
                                        />
                                        <HexColorInput
                                            color={yelp.reviews.reviewtextColor}
                                            onChange={this.setReviewTextColor}
                                        />
                                    </div>
                                </div>
                                <div className="mjwi-row">
                                    <div className="mjwi-col50">
                                        <label>Border</label>
                                    </div>
                                    <div className="mjwi-col50 mjwi-clr-picker">
                                        <span
                                            className="clrPickerVal"
                                            onClick={toggleColorPicker}
                                            style={{ backgroundColor: yelp.cards.cardBorderColor }}
                                        ></span>
                                        <HexAlphaColorPicker
                                            color={yelp.cards.cardBorderColor}
                                            onChange={this.setCardBorderColor}
                                            style={{ display: 'none' }}
                                            className="mjwi-apfl-color-picker"
                                        />
                                        <HexColorInput
                                            color={yelp.cards.cardBorderColor}
                                            onChange={this.setCardBorderColor}
                                        />
                                    </div>
                                </div>
                                <div className="mjwi-row">
                                    <div className="mjwi-col50">
                                        <label>Background</label>
                                    </div>
                                    <div className="mjwi-col50 mjwi-clr-picker">
                                        <span
                                            className="clrPickerVal"
                                            onClick={toggleColorPicker}
                                            style={{ backgroundColor: yelp.cards.cardBgColor }}
                                        ></span>
                                        <HexAlphaColorPicker
                                            color={yelp.cards.cardBgColor}
                                            onChange={this.setCardBgColor}
                                            style={{ display: 'none' }}
                                            className="mjwi-apfl-color-picker"
                                        />
                                        <HexColorInput
                                            color={yelp.cards.cardBgColor}
                                            onChange={this.setCardBgColor}
                                        />
                                    </div>
                                </div>

                                <div className="mjwi-row">
                                    <div className="mjwi-col50">
                                        <label>Border Radius</label>
                                    </div>
                                    <div className="mjwi-col50 mjwi-row">
                                        <input
                                            type="number"
                                            name="cardBorderRadius"
                                            value={yelp.cards.cardBorderRadius || ''}
                                            onChange={handleInputChange}
                                        /> px
                                    </div>
                                </div>


                                <div className="mjwi-row">
                                    <div className="mjwi-col33">
                                        <label>Text Font Family</label>
                                    </div>
                                    <div className="mjwi-col66">
                                        {getSelectField('cardtextFontFamily', fontOptions, yelp.cards.cardtextFontFamily, handleInputChange)}
                                    </div>
                                </div>
                                <div className="mjwi-row">
                                    <div className="mjwi-col33">
                                        <label>
                                            {getCheckboxField('reactionBarStatus', yelp.cards.reactionBarStatus, handleInputChange)}
                                            Show Reactions
                                        </label>
                                    </div>
                                    <div className="mjwi-col33">
                                        <label>
                                            {getCheckboxField('reviewPhothoStatus', yelp.cards.reviewPhothoStatus, handleInputChange)}
                                            Show Photos
                                        </label>
                                    </div>
                                </div>

                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>

                    {/* Read More Settings */}
                    <AccordionItem className="mjwi-sub-accordion">
                        <AccordionItemHeading>
                            <AccordionItemButton>Read More Button</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div className="mjwi-acc-panel-wrapper">
                                <div className='mjwi-row'>
                                    <div className="mjwi-col100">
                                        <label>
                                            {getCheckboxField('readMoreStatus', yelp.button.readMoreStatus, handleInputChange)}
                                            Enable/Disbale
                                        </label>
                                    </div>
                                </div>
                                {yelp.button.readMoreStatus === 'on' && (
                                    <>
                                        <div className="mjwi-row">
                                            <div className="mjwi-col50">
                                                <label>Word Limit</label>
                                            </div>
                                            <div className='mjwi-col50 '>
                                                <input
                                                    type="number"
                                                    name="wordCountThreshold"
                                                    value={yelp.button.wordCountThreshold || ''}
                                                    onChange={handleInputChange}

                                                />
                                            </div>
                                        </div>
                                        <div className="mjwi-row">
                                            <label>Text</label>

                                            <div className='mjwi-col33 mjwi-row'>
                                                <input
                                                    type="number"
                                                    name="readButtonFontSize"
                                                    value={yelp.button.readButtonFontSize || ''}
                                                    onChange={handleInputChange}
                                                /> px
                                            </div>
                                            <div className="mjwi-col50  mjwi-clr-picker">
                                                <span
                                                    className="clrPickerVal"
                                                    onClick={toggleColorPicker}
                                                    style={{ backgroundColor: yelp.button.readButtonTextColor }}
                                                ></span>
                                                <HexAlphaColorPicker
                                                    color={yelp.button.readButtonTextColor}
                                                    onChange={this.setReadButtonTextColor}
                                                    style={{ display: 'none' }}
                                                    className="mjwi-apfl-color-picker"
                                                />
                                                <HexColorInput
                                                    color={yelp.button.readButtonTextColor}
                                                    onChange={this.setReadButtonTextColor}
                                                />
                                            </div>
                                        </div>
                                        <div className="mjwi-row">
                                            <div className="mjwi-col50">
                                                <label>Hover Text</label>
                                            </div>
                                            <div className="mjwi-col50 mjwi-clr-picker">
                                                <span
                                                    className="clrPickerVal"
                                                    onClick={toggleColorPicker}
                                                    style={{ backgroundColor: yelp.button.readButtonHoverColor }}
                                                ></span>
                                                <HexAlphaColorPicker
                                                    color={yelp.button.readButtonHoverColor}
                                                    onChange={this.setReadButtonHoverColor}
                                                    style={{ display: 'none' }}
                                                    className="mjwi-apfl-color-picker"
                                                />
                                                <HexColorInput
                                                    color={yelp.button.readButtonHoverColor}
                                                    onChange={this.setReadButtonHoverColor}
                                                />
                                            </div>
                                        </div>
                                        <div className="mjwi-row">
                                            <div className="mjwi-col33">
                                                <label>Font Family</label>
                                            </div>
                                            <div className="mjwi-col66">
                                                {getSelectField('readButtonFontFamily', fontOptions, yelp.button.readButtonFontFamily, handleInputChange)}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
            </div >
        );
    }
}

export default YelpReviews;